/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useEffect, useState } from 'react';
// import deleteicon from '../../images/Delete.png';
import Urls from '../../../utils/urls';

import { prefixPath } from '../../../utils/helpers';
import BaseUrls from '../../../utils/baseUrls';
import '../../../css/modal.css';
import apiBackendInstance from '../../../utils/axios';

interface cloudData {
  name: string
  accessKey: string
  id: string
  projects?: {
    id:string;
    name:string;
  }[]
  email?:string
}

interface prop {
  id: number | string,
  cloudName: string
}
const TabHome = ({ id, cloudName }: prop) => {
  const [entries, setEntries] = useState([] as cloudData[] | []);
  const [loading, setLoading] = useState(true);
  const theme = BaseUrls.getkey();
  const eyeIcon = `img/${theme}/eye-off.svg`;
  const copyIcon = `img/${theme}/copy.svg`;
  const deleteIcon = `img/${theme}/deleteicon.svg`;
  const [deleteKey, setDeleteKey] = useState('');
  const [cloudCredName, setCloudCredName] = useState('');
  const loaderUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);

  const callApi = () => {
    showLoader();
    apiBackendInstance.get(Urls.getNameAccessCloudsById(id.toString()), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        setEntries(response.data.data);
      }
      hideLoader();
      setLoading(false);
    }).catch(() => {
      setEntries([]);
      hideLoader();
      setLoading(false);
    });
  };
  useEffect(() => {
    callApi();
    const onReceiveMessage = (e:any) => {
      const { key } = e;
      if (key === 'updateState') {
        callApi();
      }
    };
    window.addEventListener('storage', onReceiveMessage);
    return () => {
      window.removeEventListener('storage', onReceiveMessage);
    };
  }, [id]);

  const [viewPass, setViewPass] = useState(true);
  const loadNewWindow = () => {
    const features = 'menubar=yes,location=yes,resizable=no,scrollbars=yes,status=no';
    const toAddCloud: string = prefixPath(`/addCloud/${cloudName}/${id}`);
    window.open(toAddCloud, '_blank', features);
  };
  const viewPassword = (idx: number, accessKey: string) => {
    const ids = `accessKey${idx.toString()}`;
    const pass: HTMLElement | null = document.getElementById(ids);
    if (pass) {
      if (viewPass) {
        pass.innerHTML = accessKey;
      } else {
        pass.innerHTML = '*************';
      }
      setViewPass(!viewPass);
    }
  };
  function copyText(accessKey: string | number) {
    const ptag: HTMLElement | null = document.getElementById('succ');
    if (ptag) {
      ptag.style.display = 'block';
      setTimeout(() => {
        ptag.style.display = 'none';
      }, 1500);
    }

    navigator.clipboard.writeText(accessKey.toString());
  }

  function deleteCloudCred() {
    const deleteBtn = document.getElementById('deleteNetworkBtn');
    const deleteBtn2 = document.getElementById('deleteNetworkBtn2');

    const deleteMsg = document.getElementById('deleteMsg');
    if (deleteBtn) {
      deleteBtn.style.display = 'none';
    }
    if (deleteBtn2) {
      deleteBtn2.style.display = 'none';
    }
    const modalHeadingDelete = document.getElementById('modalHeadingDelete');
    callDeleteCloudCredApi(deleteKey, deleteMsg as HTMLElement, modalHeadingDelete as HTMLElement);
  }

  function callDeleteCloudCredApi(cid:string, deleteMsg:HTMLElement, modalHeadingDelete:HTMLElement) {
    const spinner = document.getElementById('spinnerDiv');
    const modalStatus = document.getElementById('modalStatus');
    if (spinner) spinner.style.display = 'block';
    apiBackendInstance.delete(Urls.getDeleteCloudCredById(cid), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (spinner) spinner.style.display = 'none';
      if (modalHeadingDelete) {
        modalHeadingDelete.style.display = 'none';
      }
      if (modalStatus) {
        modalStatus.style.display = 'none';
      }

      if (response && response.data && response.data.success) {
        callApi();
        deleteMsg.innerHTML = '<span class="alert alert-success text-center p-2">successfully deleted cloud cred</span>';
        deleteMsg.style.display = 'block';
      } else {
        deleteMsg.innerHTML = (response && response.data && response.data.message)
          ? `<span class="alert alert-success text-center p-2">there was some problem : ${response.data.message}<span class="text text-danger">`
          : '<span class="alert alert-danger text-center p-2">there was some problem deleting this cloud cred</span>';
        deleteMsg.style.display = 'block';
      }
    })
      .then(() => setTimeout(hideModal, 2000)).catch((error) => {
        if (spinner) spinner.style.display = 'none';
        if (modalStatus) {
          modalStatus.style.display = 'block';
        }
        if (modalHeadingDelete) {
          modalHeadingDelete.style.display = 'none';
        }
        // eslint-disable-next-line no-console
        if (error.response && error.response.data && error.response.data.message) {
          deleteMsg.innerHTML = `<span class="alert text-center p-2" style="color: #842029;">${error.response.data.message}</span>`;
        } else {
          deleteMsg.innerHTML = `<span class="alert text-center p-2" style="color: #842029;" >there was some problem deleting this cloud cred : ${error.message}</span>`;
        }
        deleteMsg.style.display = 'block';
      });
  }
  function showModal(mid:string, name:string) {
    setDeleteKey(mid);

    setCloudCredName(name);
    const modal: HTMLElement | null = document.getElementById('deleteModal');
    const deleteMsg = document.getElementById('deleteMsg');
    const deleteBtn = document.getElementById('deleteNetworkBtn');
    const deleteBtn2 = document.getElementById('deleteNetworkBtn2');
    const modalHeadingDelete = document.getElementById('modalHeadingDelete');
    const modalStatus = document.getElementById('modalStatus');
    if (modalStatus) {
      modalStatus.style.display = 'none';
    }
    if (modalHeadingDelete) {
      modalHeadingDelete.style.display = 'block';
    }

    if (deleteBtn2) {
      deleteBtn2.style.display = 'block';
    }
    if (deleteMsg) {
      deleteMsg.style.display = 'none';
    }
    if (deleteBtn) {
      deleteBtn.style.display = 'block';
    }
    if (modal) {
      modal.style.display = 'block';
    }
  }

  const hideModal = () => {
    const modal: HTMLElement | null = document.getElementById('deleteModal');
    if (modal) {
      modal.style.display = 'none';
    }
    callApi();
  };
  const showLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'block';
  };
  const hideLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'none';
  };
  const getCloudName = () => {
    if (cloudName === 'aws') { return 'AWS'; }
    if (cloudName === 'digitalocean') {
      return 'DigitalOcean';
    }
    if (cloudName === 'gcp' || cloudName === 'GCP') return 'GCP';

    if (cloudName === 'tencent') return 'Tencent';
    return '';
  };

  return (
    <div
      className="tab-pane fade show active"
      id="nav-home"
      role="tabpanel"
      aria-labelledby="nav-home-tab"
    >
      <div className="text-end mt-4 col-10">
        <button type="button" className="btn comingSoon" onClick={() => { loadNewWindow(); }}>{`Add ${getCloudName()} Cloud`}</button>
      </div>
      <div id="succ" className="alert alert-success mt-3 mb-5" style={{ display: 'none' }} role="alert">Key Copied</div>
      {!loading && entries.length === 0 && (
        <div style={{ color: '#ABB2B9', textAlign: 'center', fontSize: '20px' }}>
          No Data
        </div>
      )}
      <div className="col-10">
      {entries.length > 0
        && (
          <table className="table mt-4 text-center">
            <thead className="head-bg">
              { cloudName.toLowerCase() === 'aws'
              && (
              <tr>
                <th className="col-1">Account Name</th>
                <th className="col-3">Access Key</th>
                <th className="col-1">Action</th>
              </tr>
              )}
              { (cloudName.toLowerCase() === 'digitalocean' || cloudName.toLowerCase() === 'digital ocean')
              && (
              <tr>
                <th className="col-1">Account Name</th>
                <th className="col-1">Action</th>
              </tr>
              )}
              { (cloudName.toLowerCase() === 'gcp')
              && (
              <tr>
                <th className="col-1">Name</th>
                <th className="col-1">Email account</th>
                <th className="col-1">Projects</th>
                <th className="col-1">Action</th>
              </tr>
              )}
               { (cloudName.toLowerCase() === 'tencent')
              && (
              <tr>
                <th className="col-1">Account Name</th>
                <th className="col-1">Action</th>
              </tr>
              )}
            </thead>
            <tbody className="tableTextColor ">
              {entries.length > 0 && entries.map((d: cloudData, idx) => (
                <tr key={d.id}>
                  <td className="">{d.name}</td>
                  {cloudName.toLowerCase() === 'gcp' && (<td className="">{d.email}</td>)}
                  {cloudName.toLowerCase() === 'aws' && (
                      <td>
                      {' '}
                      <span id={`accessKey${idx}`}>***************</span>
                      </td>
                  )}
                 {cloudName.toLowerCase() === 'gcp' && (<td className="">{d.projects?.map((e) => (<span className="badge bg-white text-primary m-1 border">{e.name}</span>))}</td>)}
                  <td className="">
                    {cloudName.toLowerCase() === 'aws' && (
                    <img
                      src={eyeIcon}
                      height="14px"
                      title="View Password"
                      alt=""
                      onClick={() => { viewPassword(idx, d.accessKey); }}
                    />
                    )}
                    {cloudName.toLowerCase() === 'aws' && <img src={copyIcon} className="mx-2" height="14px" title="Copy" alt="" onClick={() => { copyText(d.accessKey); }} />}
                    <img src={deleteIcon} className="" height="14px" title="Delete" alt="" onClick={() => { showModal(d.id, d.name); }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <p
        id="copy"
        style={{
          display: 'none', color: '#ABB2B9', textAlign: 'center', fontSize: '20px',
        }}
      >
        {' '}
        id
      </p>
      <div id="deleteModal" className="workModal text-black" style={{ display: 'none' }}>
        <div className="workModalContent">
          <span onClick={() => { hideModal(); }} className="closeWork">&times;</span>
            <h6 className="modalHeading mb-4 text-center" id="modalHeadingDelete">
              Are you sure you want to delete
              {' '}
              <strong>
              {cloudCredName}
              </strong>
              {' '}
              accounts
              ?
            </h6>
            <h6 className="modalHeading mb-4 text-center" style={{ color: '#842029', display: 'none' }} id="modalStatus">
              Error in Deletion
            </h6>
            <p id="deleteMsg" className="mt-3 center-block mb-1" style={{ display: 'none' }}>
              {`Error Deleting Cloud Cred ${cloudCredName} `}
            </p>
            <div className="text-center">
                  <button type="button" style={{ margin: 'auto' }} id="deleteNetworkBtn" className="btn comingSoon" onClick={() => { deleteCloudCred(); }}>Yes</button>
            </div>
        </div>
      </div>
      <div
        id="spinnerDiv"
        className="text-center mx-5 p-3 col-11 "
        style={{ display: 'none' }}
      >
        <img className="" style={{ margin: 'auto' }} src={loaderUrl} alt="spinnner" />
      </div>
    </div>
  );
};

export default TabHome;
